import { EventBuilder } from './EventBuilder';
import { DDNAEvents } from './Tracker';

export enum SocialActionTypes {
    SEND_LIFE = 'send life',
    REQUEST_LIFE = 'request life',
    CHALLENGE = 'challenge',
    INVITE = 'invite',
    SHARE = 'share',
    REWARDED_INVITE = 'rewarded invite',
    SEND_COIN = 'send coin',
    REQUEST_COIN = 'request coin',
    SEND_GIFT = 'send gift',
    REQUEST_GIFT = 'request gift',
    NONE = 'none',
}

export interface ISocialParams {
    socialActionType: SocialActionTypes;
    targetUserID: string;
}

export class SocialParamBuilder extends EventBuilder {
    constructor() {
        super();
    }

    public getParams<T>(event: DDNAEvents, data: Partial<ISocialParams>): ISocialParams {
        const defaultParams: ISocialParams = {
            socialActionType: SocialActionTypes.INVITE,
            targetUserID: 'none',
        };

        return Object.assign(defaultParams, data);
    }

    public setParams(keys: Map<string, unknown>): void {
        keys.forEach((value, key) => {});
    }
}

export function isSocialSend(actionType: SocialActionTypes) {
    switch (actionType) {
        case SocialActionTypes.CHALLENGE:
        case SocialActionTypes.INVITE:
        case SocialActionTypes.SEND_COIN:
        case SocialActionTypes.SEND_LIFE:
            return 1;
        default:
            return 0;
    }
}

export function isSocialRecieve(actionType: SocialActionTypes) {
    switch (actionType) {
        case SocialActionTypes.REQUEST_LIFE:
        case SocialActionTypes.REQUEST_COIN:
        case SocialActionTypes.REWARDED_INVITE:
            return 1;
        default:
            return 0;
    }
}
